import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import axios from "axios";
import { V_URL } from "../../../../BaseUrl";
import DropDown from "../../../../Components/DropDown";
import Header from "../../Include/Header";
import Sidebar from "../../Include/Sidebar";
import Footer from "../../Include/Footer";
import Loader from "../../Include/Loader";
import { Pagination, Search } from "../../Table";
import { getStorePayment } from "../../../../Store/Store/StoreMaster/PaymentMethod/getPaymentList";
import { useMemo } from "react";

const PaymentList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [disable, setDisable] = useState(true);
  const [totalItems, setTotalItems] = useState(0);

  const fetchData = async () => {
    if (!disable) return;
    try {
      await dispatch(getStorePayment({ status: "" }));
      setDisable(false);
    } catch (error) {
      console.log(error);
      setDisable(false);
    }
  };

  useEffect(() => {
    setDisable(true);
  }, [currentPage, limit]);

  useEffect(() => {
    fetchData();
  }, [disable]);

  const entity = useSelector((state) => state?.getPaymentList?.user?.data);

  const paymentList = entity?.list || [];

  const commentsData = useMemo(() => {
    let computedComments = paymentList;
    if (search) {
      computedComments = computedComments.filter((cat) =>
        cat.name?.toLowerCase()?.includes(search?.toLowerCase())
      );
    }

    setTotalItems(computedComments?.length);
    return computedComments?.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit
    );
  }, [currentPage, search, limit, entity]);

  const handleDelete = (id, title) => {
    Swal.fire({
      title: `Are you sure want to delete ${title}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const myurl = `${V_URL}/user/payment-method-delete-status/${id}`;

        axios({
          method: "put",
          url: myurl,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
          },
        })
          .then((response) => {
            if (response.data.success === true) {
              toast.success(response?.data?.message);
              setDisable(true);
              fetchData();
            } else {
              toast.error(response?.data?.message);
            }
          })
          .catch(() => {
            toast.error("Something went wrong");
          });
      }
    });
  };

  const handleRefresh = () => {
    setSearch("");
    setCurrentPage(1);
    setDisable(true);
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/main-store/user/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right"></i>
                  </li>
                  <li className="breadcrumb-item active">
                    Payment Method List
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {disable === false ? (
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div className="doctor-table-blk">
                            <h3>Payment Method List</h3>
                            <div className="doctor-search-blk">
                              <div className="top-nav-search table-search-blk">
                                <form>
                                  <Search
                                    onSearch={(value) => {
                                      setSearch(value);
                                      setCurrentPage(1);
                                    }}
                                  />
                                  {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                  <a className="btn">
                                    <img
                                      src="/assets/img/icons/search-normal.svg"
                                      alt="search"
                                    />
                                  </a>
                                </form>
                              </div>
                              <div className="add-group">
                                <Link
                                  to="/main-store/user/manage-payment-method"
                                  className="btn btn-primary add-pluss ms-2"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Add"
                                >
                                  <img
                                    src="/assets/img/icons/plus.svg"
                                    alt="plus-icon"
                                  />
                                </Link>
                                <button
                                  type="button"
                                  onClick={handleRefresh}
                                  className="btn btn-primary doctor-refresh ms-2"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Refresh"
                                >
                                  <img
                                    src="/assets/img/icons/re-fresh.svg"
                                    alt="refresh"
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                          <DropDown
                            limit={limit}
                            onLimitChange={(val) => {
                              setLimit(val);
                              setCurrentPage(1);
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="table border-0 custom-table mb-0">
                        <thead>
                          <tr>
                            <th>Sr.</th>
                            <th>Name</th>
                            <th>Status</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {commentsData?.length > 0 ? (
                            commentsData?.map((elem, i) => (
                              <tr key={elem?._id}>
                                <td>{(currentPage - 1) * limit + i + 1}</td>
                                <td className="fw-medium">{elem?.name}</td>
                                <td className="status-badge">
                                  {elem.status ? (
                                    <span className="custom-badge status-green">
                                      True
                                    </span>
                                  ) : (
                                    <span className="custom-badge status-pink">
                                      False
                                    </span>
                                  )}
                                </td>

                                <td className="text-end">
                                  <div className="dropdown dropdown-action">
                                    <a
                                      href="#"
                                      className="action-icon dropdown-toggle"
                                      data-bs-toggle="dropdown"
                                    >
                                      <i className="fa fa-ellipsis-v"></i>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end">
                                      <button
                                        type="button"
                                        className="dropdown-item"
                                        onClick={() =>
                                          navigate(
                                            "/main-store/user/manage-payment-method",
                                            { state: elem }
                                          )
                                        }
                                      >
                                        <i className="fa-solid fa-pen-to-square m-r-5"></i>
                                        Edit
                                      </button>
                                      <button
                                        type="button"
                                        className="dropdown-item"
                                        onClick={() =>
                                          handleDelete(elem?._id, elem.name)
                                        }
                                      >
                                        <i className="fa fa-trash-alt m-r-5"></i>
                                        Delete
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="999">
                                <div className="no-table-data">
                                  No Data Found!
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="row align-center mt-3 mb-2">
                      <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                        <div
                          className="dataTables_info"
                          id="DataTables_Table_0_info"
                          role="status"
                          aria-live="polite"
                        >
                          {" "}
                          Showing {commentsData?.length} of {totalItems} records
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                        <div
                          className="dataTables_paginate paging_simple_numbers"
                          id="DataTables_Table_0_paginate"
                        >
                          <Pagination
                            total={totalItems}
                            itemsPerPage={limit}
                            currentPage={currentPage}
                            onPageChange={(page) => setCurrentPage(page)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Loader />
          )}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default PaymentList;
